<template>
    <router-view></router-view>
</template>

<script type="text/babel">

	export default {
	}
</script>

<style>
    #confidence{width: 100px; padding: 0 0 0 40px; margin-top: -16px;}
    .confidence{width:100px;}
    .confidence0{fill-rule:evenodd;clip-rule:evenodd;fill:#FF007F;}
    .confidence1{fill-rule:evenodd;clip-rule:evenodd;fill:#00FFC8;}
    .confidence2{fill-rule:evenodd;clip-rule:evenodd;fill:#FF6D52;}
    .confidence3{fill-rule:evenodd;clip-rule:evenodd;fill:#394A49;}
</style>



// WEBPACK FOOTER //
// Reserving.vue?a2e8c608